<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <transition name="fade" mode="out-in">
            <component :is="form" @snackbar="openSnackbar" />
          </transition>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar.show" :timeout="-1">
        {{ snackbar.msg }}
        <v-btn color="accent" text @click="snackbar.show = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import { snackbar } from '@/components/Mixins/Messages';

export default {
  mixins: [
    snackbar,
  ],
  props: {
    form: String,
  },
};
</script>
